import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Home', href: '/', type: 'route' },
    { name: 'Services', href: '/services', type: 'route' },
    { name: 'How It Works', href: '#how-it-works', type: 'anchor' },
    { name: 'About', href: '#about', type: 'anchor' },
    { name: 'Contact', href: '#contact', type: 'anchor' },
  ];

  return (
    <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
    }`}>
      <nav className="container-center">
        <div className="flex items-center justify-between py-4 px-4 sm:px-6 lg:px-8">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img src="/favicon.png" alt="FractionalVA Logo" className="w-32 h-auto" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              item.type === 'route' ? (
                <Link
                  key={item.name}
                  to={item.href}
                  className="text-olive-brown hover:text-burnt-orange transition-colors duration-300 font-medium"
                  aria-label={`Navigate to ${item.name}`}
                >
                  {item.name}
                </Link>
              ) : (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-olive-brown hover:text-burnt-orange transition-colors duration-300 font-medium"
                  aria-label={`Navigate to ${item.name}`}
                >
                  {item.name}
                </a>
              )
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <a
              href="#contact"
              className="btn-primary"
              aria-label="Book a Quick Call - 15 minutes. No pressure. Just clarity."
              title="15 minutes. No pressure. Just clarity."
            >
              Book a Quick Call
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 text-olive-brown hover:text-burnt-orange transition-colors duration-300"
            aria-label="Toggle mobile menu"
            aria-expanded={isMenuOpen}
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        <div className={`lg:hidden transition-all duration-300 ${
          isMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
        } overflow-hidden`}>
          <div className="px-4 py-4 bg-white/95 backdrop-blur-md">
            <div className="flex flex-col space-y-4">
              {navItems.map((item) => (
                item.type === 'route' ? (
                  <Link
                    key={item.name}
                    to={item.href}
                    className="text-olive-brown hover:text-burnt-orange transition-colors duration-300 font-medium py-2"
                    onClick={() => setIsMenuOpen(false)}
                    aria-label={`Navigate to ${item.name}`}
                  >
                    {item.name}
                  </Link>
                ) : (
                  <a
                    key={item.name}
                    href={item.href}
                    className="text-olive-brown hover:text-burnt-orange transition-colors duration-300 font-medium py-2"
                    onClick={() => setIsMenuOpen(false)}
                    aria-label={`Navigate to ${item.name}`}
                  >
                    {item.name}
                  </a>
                )
              ))}
              <a
                href="#contact"
                className="btn-primary mt-4"
                onClick={() => setIsMenuOpen(false)}
                aria-label="Book a Quick Call - 15 minutes. No pressure. Just clarity."
                title="15 minutes. No pressure. Just clarity."
              >
                Book a Quick Call
              </a>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;